/* nuvia-drag-scroll.js — arrastre con mouse de las filas [data-nv-drag]. Sale de snippets/nuvia-drag-scroll.liquid
   (24-oct, velocidad): antes viajaba en linea 4-6 veces por pagina; ahora una sola vez y cacheable. */
(function(){
  if (window.__nvDragScroll) return;      /* el snippet se renderiza en varias secciones */
  window.__nvDragScroll = true;

  /* Cuantos pixeles hay que mover el mouse para que el gesto sea un arrastre y no un
     clic. Por debajo de esto no se toca nada: ni la clase, ni el scroll, ni el clic.
     La frontera real esta en 9px (la comparacion es `>`). Referencias: Windows arranca
     un arrastre a los 4px y Android a los 8dp — 8 es el techo razonable, que es el lado
     correcto para este bug: de los dos errores posibles, comerse un clic es el caro. */
  var DRAG_PX = 8;
  /* 🟡 Residual conocido y MEDIDO: pasado el umbral, el clic del final se descarta
     aunque la fila no se haya movido (p.ej. en la primera tarjeta, arrastrando hacia la
     derecha con el scroll ya en el tope). Se probo condicionar la supresion al
     desplazamiento REAL de la fila y NO alcanza: para cuando se suelta, la clase
     `nv-is-dragging` ya apago los enlaces y el hit-test del `mouseup` cayo fuera del
     <a>, asi que el clic no se recupera por no suprimirlo — medido, no supuesto.
     Arreglarlo de verdad pide no apagar los enlaces hasta que la fila se mueva, que es
     un rediseño mas grande. Cuesta un clic raro, no una venta: para llegar aca hay que
     mover el mouse mas de 8px con el boton apretado, que ya no es un clic. */

  function wire(el){
    if (el.__nvWired) return;
    el.__nvWired = true;

    /* `down` = el boton esta apretado (todavia no se sabe que gesto es).
       `dragging` = ya cruzo DRAG_PX, o sea es un arrastre de verdad. */
    var down = false, dragging = false, startX = 0, startScroll = 0, pid = null;
    var suppressClick = false, supprT = null;

    el.addEventListener('pointerdown', function(e){
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      /* Invariante: al apretar no se esta arrastrando. Va incondicional porque si un
         `pointerup` se pierde (alt-tab, menu contextual, un dialogo de Windows robando
         el foco) el gesto anterior quedo con la clase puesta, y sin esta linea el
         `dragging = false` de abajo se lleva el unico flag que habilitaba sacarla: el
         `pointer-events:none` se queda para siempre y la fila entera deja de ser
         clickeable por el resto de la sesion, sin curarse con ningun clic. Es el mismo
         bug que este snippet vino a cerrar, pero permanente en vez de intermitente. */
      el.classList.remove('nv-is-dragging');
      down = true; dragging = false; pid = e.pointerId;
      startX = e.clientX; startScroll = el.scrollLeft;
      suppressClick = false; clearTimeout(supprT);
    });

    el.addEventListener('pointermove', function(e){
      if (!down || e.pointerId !== pid) return;
      /* Red por si el `pointerup` se perdio (alt-tab, menu contextual, un dialogo del
         sistema): el primer movimiento del mouse con NINGUN boton apretado cierra el
         gesto colgado. Sin esto la fila se queda con los enlaces apagados hasta el
         proximo clic, y el clic que la rescata es el que se pierde. */
      if (!e.buttons){ end(e); return; }
      var dx = e.clientX - startX;
      if (!dragging){
        if (Math.abs(dx) <= DRAG_PX) return;
        /* Recien aca empieza el arrastre. Se re-ancla el origen en la posicion actual
           para que la fila siga al mouse 1:1 y no salte los DRAG_PX del umbral. */
        dragging = true;
        startX = e.clientX; startScroll = el.scrollLeft; dx = 0;
        /* Se captura el puntero recien ACA (no en el pointerdown, para no tocar el
           retargeting de los eventos de mouse en un gesto que todavia puede ser un
           clic): el arrastre deja de morirse cuando el mouse se sale de la fila, que
           con una fila de ~1180px pasa seguido. Y cierra un agujero medido: sin esto
           `pointerleave` cortaba el gesto y SACABA la clase con el boton apretado, asi
           que volver a entrar y soltar sobre una tarjeta abria su ficha sin querer. */
        try { el.setPointerCapture(pid); } catch (err) {}
        el.classList.add('nv-is-dragging');
        el.dispatchEvent(new CustomEvent('nv-drag-start'));
      }
      e.preventDefault();
      el.scrollLeft = startScroll - dx;
    });

    function end(e){
      if (!down || (e && e.pointerId !== pid)) return;
      down = false;
      if (pid !== null){ try { el.releasePointerCapture(pid); } catch (err) {} }
      pid = null;
      /* El remove va SUELTO, no dentro del `if`: es la unica forma de garantizar que
         nunca queda una fila con los enlaces apagados (ver el invariante de arriba). */
      el.classList.remove('nv-is-dragging');
      if (dragging){
        dragging = false;
        suppressClick = true;
        clearTimeout(supprT);
        supprT = setTimeout(function(){ suppressClick = false; }, 350);
      }
    }
    /* El cierre se escucha en `window`, no en la fila. Con mouse NO hay captura
       implicita: si el gesto termina afuera, un listener puesto en la fila nunca se
       enteraria y el estado quedaria colgado (antes eso lo tapaba `pointerleave`, que
       cortaba el arrastre de mas). Con `setPointerCapture` el evento igual pasa por la
       fila y sube hasta aca, y si la captura fallo este listener es la unica red. El
       guard de `pid` descarta los punteros ajenos y `end` es idempotente. */
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    el.addEventListener('dragstart', function(e){ e.preventDefault(); });

    el.addEventListener('click', function(ev){
      if (suppressClick){ ev.preventDefault(); ev.stopPropagation(); }
      suppressClick = false;   /* se limpia siempre, haya arrastrado o no */
    }, true);
  }

  function init(){
    var els = document.querySelectorAll('[data-nv-drag]');
    for (var i = 0; i < els.length; i++) wire(els[i]);
  }
  /* en DOMContentLoaded para que existan las filas de secciones posteriores */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
